<template>

    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card login-dark">
                    <div>
                       
                        <div class="login-main"  >

                            <h4>Fill Your Details </h4>
                            
                            <div class="form-group">
                                <label class="col-form-label">Your Name</label>
                                <input class="form-control" type="text" v-model="user.name"  @input="user.name = user.name.charAt(0).toUpperCase() + user.name.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Firm Name</label>
                                <input class="form-control" type="text" v-model="user.firmname"  @input="user.firmname = user.firmname.charAt(0).toUpperCase() + user.firmname.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Address</label>
                                <input class="form-control" type="text" v-model="user.address" @input="user.address = user.address.charAt(0).toUpperCase() + user.address.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Designation</label>
                                <input class="form-control" type="text" v-model="user.designation" @input="user.designation = user.designation.charAt(0).toUpperCase() + user.designation.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>

                            
                            <div class="form-group">
                                <label class="col-form-label" >Adhaar Card   </label> 
                                <input class="form-control" type="file"  @change="handleFileUpload"  ref="fileInput"   
                                    required=""  style="display: none;"><br>
                                    <img :src=" imageUrls ?imageUrls: this.$hostname+'/writable/visitors/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                             
                            </div>
                       
                               

                                <!-- <div>
                                <img :src=" imageUrls || this.$hostname+'assets/file.png"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                                </div> -->



                            <div class="text-end mt-3">
                                <button class="btn btn-primary btn-block w-100" @click="saveData">Submit</button>
                            </div>

                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>





</template>
<style scoped>
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
</style>

<script>
import axios from 'axios';

export default {
    name: 'VisitorProfile',
    components: {

    },
    mounted() {
        
    },
    data() {
        return {
            user:{
            name: '',
            firmname: '',
            address: '',
            designation:'',
            file:''
            },
            imageUrls: null,
        }
    },
    methods: {  
    saveData() {

        var self = this;
           if (self.user.name == '')
           {
              self.$swal("Please Enter Name");
           }
           else if (self.user.firmname== '')
           {
               self.$swal("Please Enter Firm Name");
           }  
          else if (self.user.address == '')
          { 
             self.$swal("Please Enter Address");
          }

           else if (self.user.designation == '')
            {
             self.$swal("Please Enter Designation");
            }
            else if (self.user.file == '')
            {
             self.$swal("Please Upload Adhaar Card");
            }
        else{
       
            axios.post('saveProfile',self.user,{headers: {
               'Content-Type': 'multipart/form-data' 
          }}).then(function (response) {
                if(response.data.is==1){ 
                    self.$swal({
                            title: "Successfull",
                            text: "Please Select Option From Bellow",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonText: "Profile",
                            confirmButtonText: "Create Gatepass"
                        }).then((result) => { // <--
                            if (result.value) { // <-- if confirmed
                                self.$router.push({ name: "visitorcreategatepass" });  
                            }else
                                self.$router.push({ name: "visitorpage" });  
                        });
                        //self.$router.push({ name: "visitorpage" });  
                }else
                self.$swal("Please Try Again");

                window.scrollTo(0, 0);
            });
        }
  
    },
    handleFileUpload(event) {
    const file = event.target.files[0];
    this.user.file = file;

    if (file) {
      this.imageUrls = URL.createObjectURL(file);
    }
  },

  triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      } else {
        console.warn("File input ref not found!");
      }
    },
    visitorprofile(){ 
            this.$router.push({ name: "capture" });   
        },

       

}
}
</script>
